export default __webpack_public_path__ + "static/media/List-documentation.67e269bb.md";